export default __webpack_public_path__ + "static/media/pammContentIcon.06e59461.webp";